export enum ReferenceTypes {
  ExternalReference = 'ExternalReference',
  ModelReference = 'ModelReference',
}
